import React from "react";

import "./App.css";

import PaymentStatus from "./components/PaymentStatus/PaymentStatus";

const App: React.FC = () => {
  return <PaymentStatus />;
};

export default App;
